import styled from "styled-components";

export const FooterContainer = styled.footer`
    width: 100%;
    background: var(--color-footer);
    margin-top: 100px;
    padding: 60px 40px 40px;
    display: grid;
    grid-template-columns: 1.2fr 1fr 1fr 1fr;
    gap: 36px;
    color: white;

    @media (max-width: 900px) {
        grid-template-columns: 1fr 1fr;
        padding: 50px 32px 32px;
        gap: 32px;
    }

    @media (max-width: 600px) {
        grid-template-columns: 1fr;
        padding: 40px 24px 32px;
        gap: 30px;
        margin-top: 60px;
    }
`;

export const FooterBlocs = styled.div`
    display: flex;
    flex-direction: column;
    color: white;
`;

export const FooterTitle = styled.p`
    font-size: 26px;
    font-weight: 800;
    color: white;
    margin: 0 0 18px;
    letter-spacing: -0.3px;
`;

export const FooterSecondText = styled.p`
    font-size: 18px;
    font-weight: 700;
    color: white;
    margin: 0 0 18px;
    letter-spacing: 0.2px;
    text-transform: uppercase;
    position: relative;
    padding-bottom: 12px;

    &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 36px;
        height: 3px;
        background: var(--color-primary-light);
        border-radius: 2px;
    }
`;

export const ContactBlock = styled.div`
    display: flex;
    align-items: center;
    color: white;
    margin-top: 14px;
    font-size: 14px;
    line-height: 1.5;
`;

export const MainText = styled.div`
    color: rgba(255, 255, 255, 0.85);
    margin-top: 10px;
    font-size: 14px;
    transition: var(--transition);

    &:hover {
        color: white;
        transform: translateX(2px);
    }

    a {
        text-decoration: none;
        color: inherit;
    }
`;

export const FooterIconCircle = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 34px;
    height: 34px;
    background: rgba(255, 255, 255, 0.12);
    border-radius: 50%;
    margin-right: 12px;
    flex-shrink: 0;

    img {
        width: 16px;
        height: 16px;
        margin: 0;
    }
`;

export const FooterIconSocial = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 38px;
    height: 38px;
    background: rgba(255, 255, 255, 0.12);
    border-radius: 50%;
    cursor: pointer;
    margin-right: 10px;
    transition: var(--transition);

    &:hover {
        background: var(--color-primary);
        transform: translateY(-2px);
    }

    a {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
    }

    img {
        width: 18px;
        height: 18px;
        margin: 0;
    }
`;

export const FooterText = styled.div`
    color: rgba(255, 255, 255, 0.9);
    font-size: 14px;
    line-height: 1.55;
`;

export const FooterPhones = styled.div`
    color: rgba(255, 255, 255, 0.9);
    font-size: 14px;
    line-height: 1.55;

    p {
        margin: 0 0 3px;
        color: rgba(255, 255, 255, 0.9);
    }
`;
